<p>
  <ng-container *ngTemplateOutlet="length ? falseIcon : trueIcon"></ng-container>
  {{ 'accountUi.passwordChecklist.minCharacters' | transloco }}
</p>
<p>
  <ng-container *ngTemplateOutlet="numbers ? falseIcon : trueIcon"></ng-container>
  {{ 'accountUi.passwordChecklist.oneNumber' | transloco }}
</p>
<p>
  <ng-container *ngTemplateOutlet="letters ? falseIcon : trueIcon"></ng-container>
  {{ 'accountUi.passwordChecklist.oneLetter' | transloco }}
</p>

<ng-template #trueIcon>
  <yat-icon id="d9296d07-0510-4255-a791-65b96d504792" name="x-circle-duo"></yat-icon>
</ng-template>

<ng-template #falseIcon>
  <yat-icon id="a1b94383-431f-4b3e-bacc-b323daa3cb8c" name="cross-check-duo"></yat-icon>
</ng-template>
